module.exports = __webpack_public_path__ + "img/Invix.4cbd4d74.png";